// Lista de autódromos argentinos usados por el módulo Pit Engineer.
// Incluye tanto pistas de Turismo Pista/TN/CarShow como simracing.
// El valor "" representa "Otro..." (texto libre en un input aparte).
export const AUTODROMOS = [
  'Autódromo de Concordia',
  'Autódromo de Paraná',
  'Autódromo de Concepción del Uruguay',
  'Autódromo de San Nicolás',
  'Autódromo de Buenos Aires (Gálvez)',
  'Autódromo de La Plata',
  'Autódromo de Rafaela',
  'Autódromo de Rosario',
  'Autódromo de Posadas',
  'Autódromo de Paraná (Parque Urquiza)',
  'Autódromo de Alta Gracia',
  'Autódromo de Río Cuarto',
  'Autódromo Oscar Cabalén (Alta Gracia)',
  'Autódromo de Termas de Río Hondo',
  'Autódromo de San Juan (Villicum)',
  'Autódromo de Mendoza',
  'Autódromo de San Luis (Potrero de los Funes)',
  'Autódromo de Salta (Martín Miguel de Güemes)',
  'Autódromo de Toay (La Pampa)',
  'Autódromo de Bahía Blanca',
  'Autódromo de Neuquén',
  'Autódromo de Comodoro Rivadavia',
  'Autódromo de Olavarría',
  'Autódromo de 9 de Julio',
  'Autódromo de Río Gallegos',
];
